pageId = 'page-enterprise-application'
page = '#' + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $form = $page.find('.form')
  $form.on 'ajax:success', (e, result) ->
    return unless result.success
    $form.hide()
    $('.plan-success-wrap').show()
